import styled from 'styled-components'

export const TransactionInfoWrapper = styled.div`
  .arrow {
    text-align: center;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .tit {
    position: relative;
  }
  .transactionHeadings {
    display: flex;
    height: 42px;
    justify-content: space-between;
    align-items: center;
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x2};
    color: ${({ theme }) => theme.colors.transactionTextColor};
    background-color: ${({ theme }) => theme.colors.transactionBgColor};
    border-radius: 5px;
    margin-bottom: 24px;
    padding-top: 20px;
    padding: 0px 20px;
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      text-align: left;
      color: #4f4f4f;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 12px;
      }
    }
  }
  .p {
    color: ${({ theme }) => theme.colors.black};
    opacity: 100%;
  }
  .typelist {
    flex: 16%;
  }
  .datelist {
    flex: 19%;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      flex: 20%;
    }
  }
  .amountlist {
    flex: 22%;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      flex: 20%;
    }
  }

  .statuslist {
    background: rgba(190, 147, 17, 0.2);
    border-radius: 40px;
    width: 87px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    .para-successful {
      color: #01c715;
      font-size: 12px;
    }
    .para-failed {
      color: #eb5757;
      font-size: 12px;
    }
    .para-processing {
      color: #be9311;
      font-size: 12px;
    }
    .para-cancelled {
      color: #eb5757;
      font-size: 12px;
    }
  }
  .successful {
    background-color: rgba(1, 199, 21, 0.2);
  }
  .failed {
    background-color: rgba(255, 114, 94, 0.2);
  }
  .processing {
    background-color: rgba(190, 147, 17, 0.2);
  }
  .cancelled {
    background-color: rgba(235, 87, 87, 0.1);
  }
  .statusTarget {
    flex: 10%;
  }
  .descriptionlist {
    flex: 33%;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      flex: 50%;
    }
  }
  .description {
    flex: 33%;
    padding-top: 20px;
  }
  .type {
    flex: 16%;
    padding-top: 20px;
    text-transform: capitalize;
  }
  .date {
    flex: 19%;
    padding-top: 20px;
  }
  .amount {
    flex: 22%;
    padding-top: 20px;
  }
  .status {
    flex: 10%;
    padding-top: 20px;
  }
  .flex {
    display: flex !important;
    align-items: center;
  }
  .option-link {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .descType {
    flex: 55%;
    display: flex;
  }
  .dateAmount {
    flex: 35%;
    display: flex;
  }
  .statusmb {
    flex: 10%;
    margin-bottom: 20px;
  }
  .descriptionmb {
    flex: 65%; //0%
    display: flex;
    margin-bottom: 20px;
  }
  .typemb {
    flex: 35%;
    margin-bottom: 20px;
  }
  .datemb {
    flex: 46%;
    margin-bottom: 20px;
  }
  .amountmb {
    flex: 54%;
    margin-bottom: 20px;
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    .descTypemb {
      display: flex;
      align-items: center;
      flex: 60%;
    }
    .dateAmountmb {
      flex-direction: column;
      display: flex;
      flex: 40%;
      align-items: flex-end;
    }
    .descriptionmb {
      flex: 20%;
      font-weight: 500;
      color: #121212;
    }
    h1 {
      font-size: 28px;
    }
    h2 {
      font-size: 32px;
    }
    h3 {
      font-size: 24px;
    }
    .typemb {
      flex: 80%;
      font-weight: normal;
      line-height: 14px;
      color: #6e7191;
    }
    .datemb h2 {
      /* font-weight: normal;
      font-size: 24px;
      line-height: 14px;
      order: 4;
      margin-top: -45px;
      color: #6e7191; */
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 140%;
      /* margin-top: 20px; */
      color: #000000;
    }
    .amountmb h3 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 140%;
      color: #27ae60;
    }
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    h1 {
      font-size: 16px;
    }
    h2 {
      font-size: 16px;
    }
    h3 {
      font-size: 14px;
    }
  }
  .description {
    flex: 40%;
    display: flex;
    margin-bottom: 20px;
  }
  .reduce {
    width: 10%;
  }
  .type {
    flex: 16%;
    margin-bottom: 20px;
    text-transform: capitalize;
  }
  .date {
    flex: 19%;
    margin-bottom: 20px;
  }
  .amount {
    flex: 13%;
    margin-bottom: 20px;
  }
  .status {
    flex: 10%;
    margin-bottom: 20px;
  }
  .transactionDesc {
    margin-left: 20px;
    /* margin-bottom: 20px; */
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-bottom: 10px;
    }
  }
  .mb {
    display: none;
  }
  .successful {
    color: #4bb543 !important;
  }
  .failed {
    color: #ff647c !important;
  }
  .processing {
    color: #f29339 !important;
  }
  .cancelled {
    color: red;
  }
  .tranImg {
    width: 60%;
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    .mb {
      display: flex;
      justify-content: space-between;
      height: 64px;
      margin-bottom: 16px;
    }
    .lg {
      display: none;
    }
    .trans-flex {
      display: flex;
      align-items: center;
    }
    h3 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 140%;
      color: #27ae60;
    }
    h2 {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 140%;
      color: #000000;
      margin-top: -13px;
    }
    .type {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 140%;
      color: #000000;
      margin-top: -5px;
      text-transform: capitalize;
    }
  }
  .transaction_loader_container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
